import { timeDivisions } from "components/TrainingPlan/TrainingPlanHelpers";
import { Button } from "components/styledComponents/Button";
import { useModal } from "hooks/useModal";
import moment from "moment";
import styled from "styled-components";
import { useSWRConfig } from "swr";
import { SpaceBooking } from "../types";

const StyledBookingData = styled.div`
    margin-bottom: 1rem;
    padding: 1rem 0.5rem;

    > div {
        display: grid;
        grid-template-columns: 0.5fr 1.5fr;

        > .header {
            font-weight: bold;
        }
    }
`;

interface Props {
    booking: SpaceBooking;
}

export const BookingConfirmationMessage = ({ booking }: Props) => {
    const [, resetModal] = useModal();
    const { mutate } = useSWRConfig();
    const bookingOnRequest = booking.status === 2 || booking.status === 0;

    const handleRefresh = () => {
        mutate(
            (key) => {
                const regex = /^space\/[0-9]*\/[0-9]{4}\/[0-9]{2}$/;
                return typeof key === "string" && regex.exec(key) !== null;
            },
            undefined,
            { revalidate: true }
        );
        resetModal();
    };

    const renderPeriodKey = () => {
        switch (booking.repeat_period?.toLowerCase()) {
            case "weekly":
                return "wöchentlich";
            case "monthly":
                return "monatlich";
            case "daily":
                return "täglich";
            case "yearly":
                return "jährlich";
            default:
                return null;
        }
    };

    return (
        <>
            {bookingOnRequest && (
                <div className="alert alert-warning mt-3">
                    <h5 className="alert-heading">Deine Anfrage wird bearbeitet!</h5>
                    <p>
                        Auf diesem Platz ist es in deinem Fall nur möglich, eine Buchung auf Anfrage zu stellen. Erst
                        wenn der Verein deine Anfrage bestätigt, ist auch die Buchung erfolgreich!
                    </p>
                    <p>Wir halten dich über den Verlauf deiner Buchung per Mail auf dem aktuellen Stand!</p>
                </div>
            )}
            <StyledBookingData>
                <h3>
                    {bookingOnRequest ? "Anfrage" : "Buchung"} #{booking.id}
                </h3>
                <hr className="my-3" />
                <div>
                    {booking.subscription && (
                        <>
                            <span className="header">Abotyp</span>
                            <span>{booking.subscription.title}</span>
                        </>
                    )}
                    <span className="header">Datum</span>
                    <span>
                        {moment(booking.start).format("ll") +
                            (booking.repeat_until ? " bis " + moment(booking.repeat_until).format("ll") : "")}
                    </span>
                    {booking.repeat_period && (
                        <>
                            <span className="header">Rythmus</span>
                            <span>{renderPeriodKey()}</span>
                        </>
                    )}
                    <span className="header">Uhrzeit</span>
                    <span>
                        {timeDivisions.times[booking.start_time]} bis {timeDivisions.times[booking.end_time]}
                    </span>
                    {booking.spaces?.length > 0 && (
                        <>
                            <span className="header">Plätze</span>
                            <span>{booking.spaces?.map((space) => space.name).join(", ")}</span>
                        </>
                    )}
                </div>
            </StyledBookingData>
            <Button block onClick={handleRefresh}>
                Abschließen
            </Button>
        </>
    );
};
